import type { IdeaDetails } from "./automationIdeas";

// One small file per workflow, so a page downloads only its own example and questions.
const files = import.meta.glob<IdeaDetails>("./idea-details/*.json", { import: "default" });

export function loadIdeaDetails(id: string): Promise<IdeaDetails | undefined> {
  return files[`./idea-details/${id}.json`]?.() ?? Promise.resolve(undefined);
}
